module.exports = __webpack_public_path__ + "assets/img/ko-b527284f.png";